import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";

import { alignVariants } from "../../utils/vanilla/alignVariants";
import { activeState } from "../../theme/activeState";
import { disabledState } from "../../theme/disabledState";

import { theme } from "../../theme/css/theme.css";

export const linkButtonStyle = style({});

export const linkButtonContainerStyle = recipe({
  base: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacings.xxs,
    borderRadius: theme.borderRadiuses.xxs,
    outlineOffset: theme.spacings.xxs,
    selectors: {
      "&:not([disabled])": {
        cursor: "pointer",
      },
      "&:not([disabled]):active": {
        ...activeState,
      },
      "&[disabled]": {
        ...disabledState,
        pointerEvents: "none",
      },
    },
  },
  variants: {
    alignSelf: alignVariants("alignSelf"),
    justifySelf: alignVariants("justifySelf"),
    variant: {
      default: {},
      accent: {
        color: theme.colors.primary,
      },
    },
  },
});

export const linkButtonTextStyle = style({
  textDecoration: "underline",
  textDecorationThickness: rem(2),
  textUnderlineOffset: rem(2),
  selectors: {
    "&:hover": {
      color: theme.colors.primaryHover,
    },
    "&:active": {
      ...activeState,
    },
    [`${linkButtonStyle}:not([disabled]):hover &`]: {
      textUnderlineOffset: rem(3),
    },
  },
});
